module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays@2-7a32d90f12a6f7a9451664e8c98b38c4.jpg";